import API from 'utils/api';
import getFormattedValues from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { API_SCHEME, API_HOST, API_PATH } from 'utils/env';

export const baseURI = 'nominas/incidencias-empleados';

const getValuesAndConfig = (values) => {
  const config = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };
  const formattedValues = getFormattedValues(values, {
    formData: config.headers,
    clean: false,
  });
  return [formattedValues, config];
};

/**
 * GET incidencias Empleados
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasEmpleados = async (params) => {
  try {
    const response = await API.get(baseURI, { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET incidencia Empleado
 * @param {number} id
 * @returns {Promise<object|null>}
 */
export const getIncidenciaEmpleado = async (id) => {
  try {
    const response = await API.get(`${baseURI}/${id}`);
    return response.data;
  } catch (err) {
    onError(err);
  }
  return null;
};

/**
 * POST incidencia Empleado
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postIncidenciaEmpleado = async (values) => {
  try {
    const response = await API.post(baseURI, ...getValuesAndConfig(values));
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH incidencia Empleado
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchIncidenciaEmpleado = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}/${id}`, ...getValuesAndConfig(values));
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE incidencia Empleado
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteIncidenciaEmpleado = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * GET incidencias Empleados (vista optimizada para tabla)
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasEmpleadosOptimized = async (params) => {
  try {
    const response = await API.get('nominas/incidencias-empleados-optimized', { params });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Incidencias Empleados Plantilla
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasEmpleadosPlantilla = async () => {
  try {
    const response = await API.get(`${API_SCHEME}://${API_HOST}${API_PATH}nominas/incidencias-empleados-obtener-plantilla-excel`, {
      headers: {
        'Content-Type': 'application/ms-excel',
      },
      responseType: 'arraybuffer',
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};

/**
 * GET Incidencias Empleados Permisos Plantilla
 * @param {object} params
 * @returns {Promise<object[]>}
 */
export const getIncidenciasEmpleadosPermisosPlantilla = async () => {
  try {
    const response = await API.get(`${API_SCHEME}://${API_HOST}${API_PATH}nominas/incidencias-empleados-permisos-obtener-plantilla-excel`, {
      headers: {
        'Content-Type': 'application/ms-excel',
      },
      responseType: 'arraybuffer',
    });
    return response.data;
  } catch (err) {
    onError(err);
  }
  return [];
};
